import { render, staticRenderFns } from "./addAgent.vue?vue&type=template&id=0c16679c"
import script from "./addAgent.vue?vue&type=script&lang=js"
export * from "./addAgent.vue?vue&type=script&lang=js"
import style0 from "./addAgent.vue?vue&type=style&index=0&id=0c16679c&prod&lang=css"
import style1 from "./addAgent.vue?vue&type=style&index=1&id=0c16679c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports